// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UisT","right":"styles_right__2qdu6"};